<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      copied: false,
      timeoutId: undefined
    }
  },
  methods: {
    async copy() {
      clearTimeout(this.timeoutId)

      const { state } = await navigator.permissions.query({ name: 'clipboard-write' })
      if (state !== 'granted') return
      navigator.clipboard.writeText(this.value)

      this.copied = true

      this.timeoutId = setTimeout(() => {
        this.copied = false
      }, 1000)
    }
  },
  render() {
    return this.$scopedSlots.default({
      copy: this.copy,
      copied: this.copied
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/providers/ClipboardProvider.vue